import React, { useState, useEffect, useRef } from 'react';
import { Text, View, Image, Pressable, ScrollView } from 'react-native';

import { store } from '../../store/store';
import { pwaGUID } from '../CommonService';
import { getOMSDetailsDateTime } from '../../utils/services/DateTimeUtils';
import { mapImageUrlToList } from '../../utils/services/oms/OMSCartUtils';
import { getFileDownloadUrlList } from '../../utils/services/oms/OMSUtils';
import { getImagePath, getPuralStringWithCount, getStringWithItemCount, isObjectNotEmpty } from '../../utils/services/CommonUtils';

import { PrimaryCTA } from '../../utils/widgets/CommonCTA';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';

import { ScreenRoute } from '../../utils/constants/ScreenRouteConstant';
import { IndiaRupee, AppVersionCode, ServiceName } from '../../utils/constants/AppConstants';

import Checkbox from 'expo-checkbox';
import AppTheme from '../../AppTheme';
import OmsStyles from '../../OmsStyle';
import TextStyle from '../../TextStyle';
import AppStyles from '../../AppStyles';
import Colors from '../../utils/constants/AppColors';

import OrderImageListView from '../../utils/widgets/chemistOrder/OrderImageList';

import * as API from '../../utils/services/api/API';
import * as AlertService from "../../utils/services/AlertLoaderService";

const OrderDetailView = (props) => {

    const [orderDetails] = useState(props.route.params?.orderData)
    const [pharmacyDetails] = useState(props.route.params?.orderData['pharmacies'][0])
    const [isActionable] = useState(props.route.params?.isActionable ?? true);
    const [imageList, updateImagesList] = useState([])
    const [omsOffers, updateOmsOffers]: any = useState([]);
    let billDetailsViewRef: any = useRef();
    const [appliedCoupon, setAppliedCoupon] = useState('');
    const [serviceCharges, setServiceCharges]: any = useState({});
    const [serviceTokenV2, updateserviceTokenV2] = useState('');
    const [showPromoNotApplicableMessg, setShowPromoNotApplicableMessg] = useState(false);

    async function getOrderImageList(pharmacyDetails) {
        if (pharmacyDetails?.['offer']['prescriptionImagesToken']) {
            let orderImageList = await getFileDownloadUrlList(
                pharmacyDetails?.['offer']['prescriptionImagesToken'], false);
            let orderImageUrlList = mapImageUrlToList(orderImageList)
            updateImagesList(orderImageUrlList)
        }
    }

    function initServiceChargeAndOffers() {
        getServiceCharge('', true);
        getPaymentOffersAndModes();
    }

    function getPaymentOffersAndModes() {
        AlertService.loaderModal.setLoader(true);
        const param = {
            pwa: true, 'appVersionCode': 900, 'locale': 'en', 'orderId': orderDetails['oid'], 'pid': pharmacyDetails['id'], 'serviceName': 'Order Medicine',
        }

        API.doPost('v2207/payment/list_payment_offers_and_modes', param).then(
            (response: any) => {
                if (response) {
                    updateOmsOffers(response['offers']);
                    localStorage.setItem('omsOffers', JSON.stringify([response['offers'][0], response['offers'][0]]))
                    global.paymentModesList = response['paymentModes'];
                    localStorage.setItem('paymentModesList', JSON.stringify(response['paymentModes']))

                    AlertService.loaderModal.setLoader(false);
                }
            })
    }

    function getServiceCharge(couponCode = '', dontStopLoader = false) {
        AlertService.loaderModal.setLoader(true);
        setShowPromoNotApplicableMessg(false);
        const reduxState = store.getState();
        const param = {
            serviceName: ServiceName.order,
            userId: reduxState.userDetails['id'],
            appVersionCode: AppVersionCode,
            couponCode: couponCode,
            availSS: true,
            pwa: true,
            omsParams: {
                userId: reduxState.userDetails['id'],
                pharmacyId: pharmacyDetails['id'],
                orderId: orderDetails['oid'],
                appGUID: pwaGUID()
            }
        }

        API.doPost('payment/get_service_charges', param).then(
            (response: any) => {
                if (response) {
                    // localStorage.setItem('serviceCharges', JSON.stringify(response['servicePricing']))
                    updateserviceTokenV2(response?.serviceTokenV2)
                    setServiceCharges(response?.servicePricing)
                    console.log('###, ', response);
                    dontStopLoader ? null : AlertService.loaderModal.setLoader(false)
                    if (response?.servicePricing['ugCouponCode'].length > 0 && response?.servicePricing['couponApplied'] == false) {
                        setShowPromoNotApplicableMessg(true);
                    } else {
                        setShowPromoNotApplicableMessg(false);
                    }
                    // completePyament();
                }
            })

    }

    useEffect(() => {
        getOrderImageList(pharmacyDetails)
        initServiceChargeAndOffers();
    }, [])

    const getItemsCount = (pharmacyDetails) => {
        let count = 0;
        if (pharmacyDetails['offer']['medications']?.length) {
            count += pharmacyDetails['offer']['medications']?.length;
        }
        if (pharmacyDetails?.['offer']?.['products']?.length) {
            count += pharmacyDetails?.['offer']?.['products'].length;
        }
        count -= pharmacyDetails?.['offer']?.['medications']?.reduce((n, item) => item?.available === false && !(item?.substitute && item?.substitute?.available) ? n + 1 : n, 0) ?? 0
        count -= pharmacyDetails?.['offer']?.['products']?.reduce((n, item) => item?.available === false ? n + 1 : n, 0) ?? 0

        return count;
    }

    const getSavingsAmount = (pharmacyDetails) => {
        if (serviceCharges) {
            return (serviceCharges['pharmacyDiscountAmount'] ? serviceCharges['pharmacyDiscountAmount'] : 0) + (serviceCharges?.discount ? serviceCharges?.discount : 0) + (serviceCharges?.maxAllowedBonus ? serviceCharges?.maxAllowedBonus : 0)
        } else if (pharmacyDetails['offer']['discount'] > 0) {
            let savingsAmount = (pharmacyDetails['offer']['totalAmount'] - pharmacyDetails['offer']['payableAmount']) - pharmacyDetails['offer']['deliveryChargeAmount']
            return savingsAmount;
        } else return 0;
    }

    function getbackServiceChargeCB(copCode) {
        setShowPromoNotApplicableMessg(false);
        setAppliedCoupon(copCode);
        getServiceCharge(copCode);
    }

    function getPayableAmount() {
        if (serviceCharges) {
            return serviceCharges['payableAmount']
        } else {
            return pharmacyDetails['offer']['payableAmount'] + pharmacyDetails['offer']['deliveryChargeAmount']
        }
    }

    return (
        <View> {orderDetails && pharmacyDetails ?
            <View style={{ backgroundColor: Colors.background, height: AppTheme.appHeight }}>

                <CommonHeader navigation={props.navigation} title={'Order & Pricing Details'} />

                <ScrollView style={{
                    backgroundColor: Colors.background,
                    paddingTop: 16, paddingBottom: 116, marginTop: AppTheme.headerHeight
                }}>{((pharmacyDetails['offer']['medications'] && pharmacyDetails['offer']['medications']?.length) ||
                    (pharmacyDetails?.['offer']?.['products'] && pharmacyDetails?.['offer']?.['products']?.length)) ?
                    <Text style={[TextStyle.text16b, AppStyles.mx16]}>
                        {getPuralStringWithCount(getItemsCount(pharmacyDetails))}</Text> : null}

                    {(pharmacyDetails['offer']['medications'] &&
                        pharmacyDetails['offer']['medications']?.length) ? <View
                            style={[AppStyles.mediumShadow, AppStyles.mx16, AppStyles.border12, {
                                marginTop: 16, paddingHorizontal: 16, paddingTop: 18, paddingBottom: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white'
                            }]}>
                        {
                            pharmacyDetails['offer']['medications']?.map((medicine, index) => (

                                <View key={medicine['mmid']}>

                                    {medicine['available'] ?

                                        medicine['substitute'] ?

                                            <View>

                                                <Text style={[TextStyle.text16b, { marginBottom: 4, color: '#0A0A0A' }]}>
                                                    {medicine['substitute']['name']}(SUBSTITUTE)</Text>

                                                <Text style={[TextStyle.text12, {
                                                    color: '#C5C6C6', marginBottom: 8,
                                                    textDecorationStyle: 'solid', textDecorationLine: 'line-through', textDecorationColor: '#C5C6C6'
                                                }]}>
                                                    {medicine['name']}</Text>

                                                <Text style={[TextStyle.text12, { fontSize: 12, color: Colors.grey.text }]}>
                                                    {medicine['quantity']} {medicine['packing']}</Text>

                                            </View> :

                                            <View>

                                                <Text style={[TextStyle.text16b, { marginBottom: 12, color: '#0A0A0A' }]}>{medicine['name']}</Text>

                                                <Text style={[TextStyle.text12, { color: Colors.grey.text }]}>
                                                    {medicine['quantity']} {medicine['packing']}</Text>

                                            </View> :

                                        medicine['substitute'] ?

                                            <View>

                                                <Text style={[TextStyle.text16b, { marginBottom: 4 }]}>
                                                    {medicine['substitute']['name']}(SUBSTITUTE)</Text>

                                                <Text style={[TextStyle.text12, {
                                                    color: '#C5C6C6', marginBottom: 8,
                                                    textDecorationStyle: 'solid', textDecorationLine: 'line-through', textDecorationColor: '#C5C6C6'
                                                }]}>
                                                    {medicine['name']}</Text>

                                                <Text style={[TextStyle.text12, { fontSize: 12, color: Colors.grey.text }]}>
                                                    {medicine['quantity']} {medicine['packing']}</Text>

                                            </View> :

                                            <View>
                                                <Text style={[TextStyle.text16, {
                                                    color: Colors.grey.text, marginTop: 8,
                                                    textDecorationStyle: 'solid', textDecorationLine: 'line-through', textDecorationColor: Colors.grey.text
                                                }]}>
                                                    {medicine['name']}<Text style={{ textDecorationLine: 'none' }}>
                                                        (UNAVAILABLE)</Text></Text>

                                                <Text style={[TextStyle.text12, { color: Colors.grey.text, opacity: 0.37 }]}>
                                                    {medicine['quantity']} {medicine['packing']}</Text>

                                            </View>}

                                    {index != pharmacyDetails['offer']['medications']?.length - 1 ?
                                        <View style={{ marginVertical: 16, marginTop: 8, height: 1, width: AppTheme.appWidth - 64, backgroundColor: Colors.grey.divider }} /> : null}
                                </View>
                            ))
                        }
                    </View> : null}

                    {(pharmacyDetails?.['offer']?.['products'] &&
                        pharmacyDetails?.['offer']?.['products']?.length != 0) ? <View style={AppStyles.mx16}>
                        {pharmacyDetails?.['offer']?.['products'].map((item, index) => (
                            <View key={item['dealId']} style={[AppStyles.mediumShadow, AppStyles.border12, {
                                paddingHorizontal: 16, paddingVertical: 16, marginVertical: 6,
                                width: AppTheme.appWidth - 32, backgroundColor: 'white'
                            }]}>
                                <View>

                                    <View style={{ width: (AppTheme.appWidth - 64) * 0.7, marginBottom: 12 }}>
                                        {item?.available == false ? <View><Text style={[TextStyle.text12, { color: Colors.red.highlight, paddingVertical: 8 }]}>{'Unavailable'}</Text></View> : null}
                                        <Text numberOfLines={2} ellipsizeMode="head" style={TextStyle.text16b}>{item.productName}</Text>

                                    </View>
                                    <Text style={[TextStyle.text12, { color: Colors.grey.text }]}>
                                        {item['quantity']} Units</Text>

                                </View>

                            </View>))}

                    </View> : null}

                    {imageList?.length ? <View style={AppStyles.mt24}>
                        <Text style={[TextStyle.text16b, AppStyles.mx16]}>
                            {getStringWithItemCount(imageList.length, 'Attachment', 'Attachments')}</Text>
                        <OrderImageListView imageList={imageList} marginTop={16} />
                    </View> : null}

                    {isObjectNotEmpty(serviceCharges) ? <View style={AppStyles.mx16}>
                        {omsOffers.length > 0 ? <View>
                            <Text style={[TextStyle.text16b, { marginTop: 24, marginBottom: 16, color: '#0A0A0A' }]}>Offers</Text>
                            <Pressable onPress={() => {
                                appliedCoupon.length == 0 ?
                                    // props.navigation.navigate(ScreenRoute.oms_offers); 
                                    props.navigation.navigate(ScreenRoute.oms_offers, {
                                        getbackServiceChargeCB: getbackServiceChargeCB, offersList: omsOffers
                                    }) : null
                            }} style={[AppStyles.mediumShadow, AppStyles.border12, { paddingHorizontal: 16, paddingVertical: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                                <View style={AppStyles.flexRowSpaceBetween}>
                                    <Image source={{
                                        uri: getImagePath(`/images/oms/rops/${appliedCoupon.length > 0 ?
                                            'offers_comps_applied' : 'offers_comps'}.svg`)
                                    }} style={{ width: 24, height: 24 }} />
                                    <View style={{ flexGrow: 1, paddingLeft: 7 }}>
                                        <Text style={[TextStyle.text16b, OmsStyles.commonTextColor]}>{appliedCoupon.length > 0 ? `Code ${appliedCoupon} applied!` : 'View all promo codes'}</Text>
                                    </View>
                                    <Pressable onPress={() => {
                                        if (appliedCoupon.length == 0) {
                                            props.navigation.navigate(ScreenRoute.oms_offers, {
                                                getbackServiceChargeCB: getbackServiceChargeCB,
                                                offersList: omsOffers
                                            })
                                        } else {
                                            setAppliedCoupon('');
                                            getServiceCharge('')
                                        }
                                    }}><Image resizeMode='cover' source={{
                                        uri: getImagePath(`/images/${appliedCoupon.length > 0 ?
                                            'icons/cancel.svg' : 'oms/rops/blue-right-chev.svg'}`)
                                    }} style={{
                                        width: appliedCoupon.length > 0 ? 18 : 6,
                                        height: appliedCoupon.length > 0 ? 18 : 10
                                    }} />
                                    </Pressable>
                                </View>
                                {showPromoNotApplicableMessg ? <Text style={[TextStyle.text12xb, {
                                    color: Colors.red.highlight, paddingLeft: 32, position: 'relative', top: 2
                                }]}>Promo code is not applicable on this order</Text> : null}

                            </Pressable>
                        </View> : null}


                        <Text style={[TextStyle.text16b, OmsStyles.commonTextColor, { marginTop: 24, marginBottom: 16 }]}>Bill Details</Text>

                        <View style={[AppStyles.mediumShadow, AppStyles.border12, { paddingHorizontal: 16, paddingVertical: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>

                            <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 12 }]}>
                                <Text style={[TextStyle.text14, OmsStyles.commonTextColor]}>Total amount</Text>
                                <Text style={[TextStyle.text14b, OmsStyles.commonTextColor]}>
                                    {IndiaRupee}{pharmacyDetails['offer']['totalAmount']}</Text>
                            </View>

                            {pharmacyDetails['offer']['deliveryChargeAmount'] > 0 && <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 12 }]}>
                                <Text style={[TextStyle.text14, OmsStyles.commonTextColor]}>Delivery fee</Text>
                                <Text style={[TextStyle.text14b, OmsStyles.commonTextColor]}>
                                    {IndiaRupee}{pharmacyDetails['offer']['deliveryChargeAmount']}</Text>
                            </View>}

                            {pharmacyDetails['offer']['discount'] > 0 ?
                                <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 12 }]}>
                                    <Text style={[TextStyle.text14, OmsStyles.commonTextColor]}>Discount from store({pharmacyDetails['offer']['discount']}%)</Text>
                                    <Text style={[TextStyle.text14b, { color: Colors.green.primary }]}>
                                        -{IndiaRupee}{pharmacyDetails['offer']['totalAmount'] - pharmacyDetails['offer']['payableAmount']}</Text>
                                </View> : null}

                            {serviceCharges.maxAllowedBonus ? <View style={[AppStyles.flexRowSpaceBetween, { marginBottom: 12 }]}>
                                <Text style={[TextStyle.text14]}>Sehat Sikke discount ({serviceCharges?.maxAllowedBonusPctDouble}%)</Text>
                                <Text style={[TextStyle.text14b, { color: 'rgba(221, 103, 0, 1)' }]}>- {IndiaRupee}{serviceCharges?.maxAllowedBonus}</Text>
                            </View> : null}

                            {serviceCharges['couponApplied'] ? <View style={[AppStyles.flexRowSpaceBetween]}>
                                <Text style={[TextStyle.text14xb, { color: 'rgba(16, 86, 172, 1)' }]}>Promo code applied!</Text>
                                <Text style={[TextStyle.text14b, { color: 'rgba(16, 86, 172, 1)' }]}>- {IndiaRupee}{serviceCharges?.serviceCost - serviceCharges?.payableAmountCash}</Text>
                            </View> : null}
                        </View>

                        <View style={{ height: 8 }} />

                        <View style={[AppStyles.mediumShadow, AppStyles.flexRowSpaceBetween, AppStyles.border12, { paddingHorizontal: 16, paddingVertical: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>

                            <Text style={[TextStyle.text14xb]}>To Pay</Text>
                            <Text style={[TextStyle.text14b]}>
                                {IndiaRupee} {getPayableAmount()}</Text>
                        </View>

                        <Text style={[TextStyle.text16b, OmsStyles.commonTextColor, { marginTop: 24, marginBottom: 16, }]}>Expected Delivery Time</Text>

                        <View style={[AppStyles.mediumShadow, AppStyles.border12, { paddingHorizontal: 16, paddingVertical: 16, width: AppTheme.appWidth - 32, backgroundColor: 'white' }]}>
                            <Text style={[TextStyle.text14, OmsStyles.commonTextColor]}>{getOMSDetailsDateTime(orderDetails['estDelTime'])}</Text>
                        </View>

                        <View ref={billDetailsViewRef} ></View>

                        <View style={{ height: 8, }} />

                        {serviceCharges.maxAllowedBonus ? <View style={[AppStyles.mediumShadow, AppStyles.flexRowStart,
                        AppStyles.border12, AppStyles.p16, AppStyles.bgWhite, { width: AppTheme.appWidth - 32 }]}>
                            <Image resizeMode='contain' source={{ uri: getImagePath('/images/oms/rops/s_sikke.svg') }}
                                style={[AppStyles.alignItemStart, { width: 24, height: 24 }]} />
                            <View style={[AppStyles.px8, { width: AppTheme.appWidth - 32 - 32 - 24 - 18 }]}>
                                <Text style={[TextStyle.text16b, { color: 'rgba(0, 0, 0, 0.87)' }]}>{'Sehat Sikke Discount'}</Text>
                                <Text style={[TextStyle.flexWrap, TextStyle.text14]}>This can only be availed for online payment modes.</Text>
                            </View>
                            <Text><Checkbox value={true} disabled={true}
                                style={{ height: 18, width: 18, borderRadius: 2 }}
                                color={true ? '#BDBDBD' : Colors.white} /> </Text>
                        </View> : null}
                    </View> : null
                    }

                </ScrollView>

                {
                    Object.keys(serviceCharges).length > 0 ?
                        <View style={[OmsStyles.bottomFix, { zIndex: 1, padding: 0 }]}>

                            {getSavingsAmount(pharmacyDetails) > 0 ?
                                <View style={{ backgroundColor: Colors.green.primary, paddingVertical: 4, alignContent: "center" }}>
                                    <Text style={[TextStyle.text12, { color: 'white', textAlign: "center" }]}>
                                        <Image source={{ uri: getImagePath('/images/icons/tick_circle_white.svg') }}
                                            style={{ marginRight: 6, width: 12, height: 12 }} />
                                        Your total savings on this order is {IndiaRupee}{getSavingsAmount(pharmacyDetails)}</Text>
                                </View> : null}


                            {/* <CommonCTA text={'Get Service Charges'} width={142} onPress={() => { getServiceChanges() }} />
                    <CommonCTA text={'Complete payment'} width={142} onPress={() => { completePyament() }} /> */}

                            {isActionable && <View style={[AppStyles.flexRowSpaceBetween, { padding: 16 }]}>
                                <View>
                                    <Text style={TextStyle.text16xb}>
                                        {IndiaRupee}{getPayableAmount()}</Text>
                                    <Text style={[TextStyle.text12, { color: Colors.primary }]}
                                        onPress={() => {
                                            setTimeout(() => {
                                                billDetailsViewRef?.current?.scrollIntoView({ behavior: "smooth" })
                                            }, 100);
                                        }}>
                                        View bill details</Text>
                                </View>

                                <PrimaryCTA
                                    text={'Make Payment'}
                                    width={142}
                                    onPress={() => {
                                        setTimeout(() => {
                                            props.navigation.navigate(ScreenRoute.custom_checkout,
                                                {
                                                    serviceName: ServiceName.order, serviceCharges: serviceCharges, serviceTokenV2: serviceTokenV2, orderDetails: orderDetails,
                                                    pharmacyDetails: pharmacyDetails
                                                })
                                        }, 200);

                                    }} />
                            </View>}

                        </View> : null
                }

                {/* <SeeExpandedImageComponent
                    imagesList={imagesList}
                    showPicViewModalIndex={showPicViewModalIndex}
                    showPicViewModal={showPicViewModal} hideFullImageViewModal={() => setShowPicViewModal(false)}
                    incOrDecViewModalIndex={(value) => {
                        value === 'inc' ? setShowPicViewModalIndex(showPicViewModalIndex + 1) :
                            setShowPicViewModalIndex(showPicViewModalIndex - 1)
                    }} /> */}

            </View> : null}
        </View>
    )
}

export default OrderDetailView